export const environment = {
  production: false,
  name: 'release',
  apiUrl: 'https://api.airgateway.live',
  apiUrlV1_5: 'https://api.airgateway.live/v1.5',
  keycloakUrl: 'https://auth.airgateway.live',
  bpUrl: 'https://web.bookingpad.live',
  registerAvailable: false,
};
